<template>
  <div>
    <div class="ldmeet-nav">
      <div class="dsxxpage-tit">十九大以来的历次全会</div>
      <el-menu
        :default-active="defaultActive"
        :default-openeds="defaultOpeneds"
        @open="handleOpen"
        class="el-menu-vertical-demo"
        router
        :unique-opened="true"
      >
        <el-submenu
          v-for="(item, i) in menuList"
          :key="item.id"
          :index="i.toString()"
        >
          <template slot="title">
            <span>{{ item.columnName }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item :index="`/QuanHuiParty/HYGB${7-i}`"
              >会议公报</el-menu-item
            >
            <el-menu-item :index="`/QuanHuiParty/Literature/${uidList[i]}/${menuList[i].columnName}`" v-if="i===0 || i === menuList.length-1"
              >相关文献</el-menu-item
            >
            <el-menu-item v-else :index="`/QuanHuiParty/Literature/${uidList[i]}/${menuList[i].columnName}`"
              >文献研究</el-menu-item
            >
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template> 
     <script>
export default {
  data() {
    return {
      defaultActive: "/QuanHuiParty/HYGB1",
      defaultOpeneds: ["0"],
      menuList: [],
      uidList: [],
    };
  },
  watch: {
    $route: {
      handler(newVal) {
        this.defaultActive = newVal.path;
      },
      deep: true,
    },
  },
  mounted() {
    const { path } = this.$route;
    this.defaultActive = path;
  },
  created(){
    this.getMenuList()
  },
  methods: {
    getMenuList() {
      this.axios
        .get(
          "data/custom/classType?uid=22fc538e-7942-47c2-a752-2590aa4d5d2c&pageNum=1&pageSize=10"
        )
        .then((res) => {
          if (res.status == 200) {
            this.menuList = res.data.rows
            this.uidList = this.menuList.map((item) => item.uid)
          } else {
            this.$message.error("获取失败！");
          }
        });
    },
    handleOpen(key, keyPath) {
      this.$router.push(`/QuanHuiParty/HYGB${7-Number(key)}`)
      this.defaultOpeneds = [`${key}`];
    },
  },
};
</script>
<style lang="scss" scoped>
.ldmeet-content {
  width: 1200px;
  height: 800px;
  margin: 30px auto;
  background-color: antiquewhite;
  .ldmeet-nav {
    position: relative;
    //    margin-top:20px;
    width: 220px;
    height: auto;
    box-sizing: border-box;
    padding: 60px 14px 10px 14px;
    background: #fff8f8;
    border: 1px solid #fae0e0;
    .dsxxpage-tit {
      position: absolute;
      z-index: 10;
      top: 0;
      left: -7px;
      width: 232px;
      height: 51px;
      text-align: center;
      line-height: 51px;
      font-size: 18px;
      color: #f9fdcc;
      //    background: url('../assets/images/dsxxpage-tit.png') no-repeat;
      background: url("../../../assets/images/dsxxpage-tit.png") no-repeat;
    }
     ::v-deep.el-menu {
      width: 200px !important;
      background: none !important;
      border: none;
    }
     ::v-deep.el-menu-item {
      margin-top: 10px;
      width: 192px;
      height: 40px;
      color: #383636 !important;
      line-height: 40px;
      //  background-color: #FAE0E0 !important;
    }
     ::v-deep.el-menu-item:hover {
      background: url("../../../assets/images/dmeet-nav.png") no-repeat;
    }
     ::v-deep.el-submenu__title {
      width: 192px;
      height: 40px;
      color: #ffffff;
      line-height: 40px;
      margin-top: 10px;
      text-align: center;
      font-size: 16px;
      //  background-color: #FAE0E0 !important;
      background: url("../../../assets/images/dmeet-nav.png") no-repeat;
      i{
        color: #fff;
      }
    }
     ::v-deep.el-submenu__title:hover {
      background: url("../../../assets/images/dmeet-nav.png") no-repeat;
    }

     ::v-deep.el-submenu .el-menu-item {
      width: 192px !important;
      min-width: 192px !important;
      text-align: left;
      background: #fff0f0;
    }
     ::v-deep.el-menu-item-group__title {
      padding: 0 !important;
    }
     ::v-deep.is-active {
      color: #b40808 !important;
      // background: #FF9142 !important;
      //    background:url('../assets/images/dmeet-nav.png') no-repeat !important;
    }
  }
}
</style>